// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"688":"WxLaunchHack","962":"QQShare"}[chunkId] + "." + {"688":"b0f2b4e7f1","962":"ebea9f19de"}[chunkId] + ".js";
};